import { setUser } from './actions';
import userStore from './store';

import type { User } from '@m/types/api';

/**
 * Mirrors a successful `/customer/update-info` save into the effector user store, synchronously,
 * so screens that read the store (e.g. the active visit page asking for an email) see the new
 * values before the caller navigates on. The endpoint replaces email / first / last name outright,
 * so an empty value is stored as null, matching the account.
 *
 * Use this instead of a getUser() refetch after the save: getUser's failure path resets the store
 * to a logged-out user, which would sign the customer out right after a successful write.
 */
export function setSavedContactInfo({
  email,
  firstName,
  lastName,
}: {
  email: string;
  firstName: string;
  lastName: string;
}) {
  const { user } = userStore.getState();
  if (!user.isRegistered) return;
  setUser({
    user: {
      ...(user as User),
      email: email || null,
      firstName: firstName || null,
      lastName: lastName || null,
    },
  });
}
